module.exports = __webpack_public_path__ + "static/media/nothing-found-grey.8aa74b06.svg";